import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';

import { colors, devices } from 'styles';
import SliderArrowIcon from 'assets/they-trust-us/slider-arrow.svg';
import SliderArrowWhiteIcon from 'assets/they-trust-us/slider-arrow-white.svg';

export const SliderArrow = styled(Box)`
  width: 48px;
  height: 48px;
  background-color: ${colors.white};
  border-radius: 50%;
  border: 1px solid ${colors.mainDark};
  position: absolute;
  left: 64px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  background-image: url(${SliderArrowIcon});
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  display: none;
  transition: all 0.25s ease;
  z-index: 1;

  &:hover {
    background-color: ${colors.blue};
    border: 1px solid ${colors.white};
    background-image: url(${SliderArrowWhiteIcon});
  }

  @media (${devices.md}) {
    display: block;
  }
`;
